import { useGetlocumgraphQuery } from "../store/query/locum";
import { useTypedSelector } from "./useTypedSelector";

export default function useChartConfig(props) {
  const { dataType = "ordinal", filters } = props || {};
  const { user } = useTypedSelector((store) => store.appUser);

  const { data: graph } = useGetlocumgraphQuery({
    acc_type: user?.account_type,
    filters,
  });
  //console.log("graph", graph);

  const graphData = Array.isArray(graph?.data)
    ? graph.data
        .filter((item) => item.day != null && item.total_amount_perday != null)
        .map((item) => ({
          primary: item.day.toString().padStart(2, "0"),
          secondary: item.total_amount_perday,
        }))
    : [];

  //console.log(graphData.slice(0, 6));

  const state = {
    dataType,
    data: [
      {
        label: "Amount",
        data: [...graphData],
      },
    ],
  };

  return {
    ...state,
  };
}
